module.exports = __webpack_public_path__ + "img/9.010e1b4c.jpg";